import React, { FC } from 'react';

import { WithColor } from '@styles/colors';
import { NCFileVersionsProps, RightColumnProps } from '@components/ncFileVersions/types';
import RightColumn from './RightColumn';

export interface NarrowColumnsProps
  extends WithColor,
    Pick<NCFileVersionsProps, 'ncFile' | 'selectedItem'>,
    Pick<RightColumnProps, 'onSendToMachine'> {
  selectedVersion: RightColumnProps['selectedVersion'] | undefined;
}

const NarrowColumns: FC<NarrowColumnsProps> = ({ C, ncFile, selectedItem, selectedVersion, onSendToMachine }) => {
  if (!ncFile || !selectedVersion) return null;

  return (
    <RightColumn
      selectedItem={selectedItem}
      C={C}
      ncFile={ncFile}
      visible={true}
      selectedVersion={selectedVersion}
      onSendToMachine={onSendToMachine}
    />
  );
};

export default NarrowColumns;
